<template>
  <v-date-picker
    v-bind="$props"
    v-on="$listeners"
    :color="color"
    :locale="locale"
  ></v-date-picker>
</template>

<script>
import { VDatePicker } from "vuetify/lib";

export default {
  name: "SDatePicker",
  extends: VDatePicker,
  props: {
    color: {
      type: String,
      default: "primaryColor",
    },
    locale: {
      type: String,
      default: "fr-fr",
    },
  },
};
</script>

<style></style>
